import { useEffect, useRef, useState } from 'react';
import { subscribeMeter, getLatestSnapshot } from './meterSocket';
import { matchMeterFieldGroup } from './meterFieldGroups';

const DEFAULT_METER_ID = 'TEST_1_1';

function applyBreakdown(snapshot, group) {
    if (!group || !snapshot || snapshot.error) return null;
    const groupData = snapshot[group.groupKey] || {};
    const values = group.subKeys.map((k) => Number(groupData[k]) || 0);
    return { labels: group.subLabels, values };
}

export default function useMeterFieldBreakdown(title, { meterId = DEFAULT_METER_ID, skip = false } = {}) {
    const group = skip ? null : matchMeterFieldGroup(title);
    const groupRef = useRef(group);
    groupRef.current = group;

    const [state, setState] = useState({ labels: [], values: [] });

    useEffect(() => {
        if (!group || skip) {
            setState({ labels: [], values: [] });
            return;
        }
        const cached = getLatestSnapshot(meterId);
        const applied = cached && applyBreakdown(cached, group);
        setState(applied || { labels: group.subLabels, values: group.subLabels.map(() => 0) });
    }, [group?.label, skip, meterId]);

    useEffect(() => {
        if (skip) return undefined;

        const handleSnapshot = (snapshot) => {
            const applied = applyBreakdown(snapshot, groupRef.current);
            if (applied) setState(applied);
        };

        return subscribeMeter(meterId, handleSnapshot);
    }, [meterId, skip]);

    return { group, ...state };
}
